import React, { useCallback } from 'react';
import DropdownMultiSelect from '../DropdownMultiSelect/DropdownMultiSelect';
import { StatusFilterTypes, getSelectedOptionsFromValues } from '../../config/FilterOptionTypes';

export default function StatusFilter(props) {

    const selectedOptions = useCallback(() => {
        return props.values ? getSelectedOptionsFromValues(StatusFilterTypes, props.values) : StatusFilterTypes;
    }, [props.values]);

    return (
        <DropdownMultiSelect options={StatusFilterTypes} selectedOptions={selectedOptions} label='Status' type='status' onChange={props.onChange} isMobile={props.isMobile} />
    );
}